import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { trackBannerClick, trackBannerShow } from './tracking';
import { useApplicationContext } from '../../../common/containers/ApplicationContext';
import { BannerVacation } from '../../components/BannerVacation';

export const BannerVacationContainer = () => {
  const context = useApplicationContext();
  const url = context.config.get<string>('Dailyrent.Hub.VacationBannerUrl') || '';

  return (
    <ActionAfterViewObserver callback={trackBannerShow} percentVisible={0.8} triggerOnce>
      <BannerVacation url={url} onClick={trackBannerClick} />
    </ActionAfterViewObserver>
  );
};

BannerVacationContainer.displayName = 'BannerVacationContainer';
